<template>
  <div
    class="tutorial-text-container"
    ref="tutorialTextContainer"
    v-show="isTextTutorialVisible"
    :class="'layout_' + layoutMode + getExtraClasses"
  >
    <div
      class="tutorial-text"
      :class="getWordCountClasses"
      v-html="textContent"
      ref="tutorialTextText"></div>
  </div>

  <div
    class="tutorial-highlight-element"
    :class="getExtraClasses"
    ref="tutorialHighlight"
    v-for="(highlight, index) of highlights"
    v-bind:key="index"
    :style="'left: ' + highlight.x + '; top: ' + highlight.y +';' "
  >
    <div class="highlight-itself"></div>
  </div>

</template>

<script>

/* tslint:disable */
/* eslint-disable */

import BusEvent            from '../../../../shared/js/BusEvent';
import { TUTORIAL_EVENTS } from '../../../../shared/js/BusEvent';
import { TutorialStore }   from '@/store/index';
import { translate }       from '@/helpers/locale-helper';

export default {
  name : "Tutorial",

  data ()
  {
    return {

      // text tutorial
      isTextTutorialVisible : true,
      textTutorialX         : 150,
      textTutorialY         : 90,
      layoutMode            : 'centered',
      textContent           : '',
      eventType             : '',

      extraClasses : [],

      // glow
      isTutorialHighlightVisible : true,
      tutorialHighlightX         : 500,
      tutorialHighlightY         : 300,

      highlights : [],

    }
  },

  computed : {
    getWordCountClasses ()
    {
      // needed a way to wrangle very short AND very long notifications/tutorial texts
      // trying to break it down with a class for "steps" of characters

      // const textCount = Math.ceil( this.textContent.length / 30 ) * 50;
      const textCount = this.textContent.length;
      let countClass  = 'small';


      if ( textCount > 0 )
      {

        if ( textCount > 58 )
        {
          countClass = 'medium';

        }

        if ( textCount > 75 )
        {
          countClass = 'large';
        }
      }


      //console.log( 'Tutorial text classes', textCount, countClass );

      return 'word-count_' + countClass;
    },


    getExtraClasses ()
    {
      return ' ' + this.extraClasses.concat( [ 'event-type_' + this.eventType.toLowerCase() ] ).join( ' ' ) + ' ';
    },


  },


  mounted ()
  {


    document.addEventListener( BusEvent.EVENTS.TUTORIAL_EVENT, this.reactToTutorialEvents );


    // document.dispatchEvent( new BusEvent( BusEvent.EVENTS.LAUNCH_TUTORIAL, { type : "test-martin-Splash-page:102-remove-me" } ) );
  },


  methods : {


    reactToTutorialEvents ( event )
    {


      const eventDetails = event.options;

      const eventType = eventDetails.type;
      let layoutMode  = eventDetails.layoutMode || 'center';
      const textX     = eventDetails.textX || false; // could be
      const textY     = eventDetails.textY || false;

      this.extraClasses = [];

      // const textContent = eventDetails.textContent;
      const highlightX = eventDetails.highlightX || false;
      const highlightY = eventDetails.highlightY || false;

      let eventHighlights = eventDetails.highlights || [];

      //console.log( "Tutorials : RECEIVED TUTORIAL EVENT", eventType );


      this.eventType = eventType;


      if ( TUTORIAL_EVENTS.CLOSE_TUTORIAL === eventType || !TUTORIAL_EVENTS.hasOwnProperty( eventType ) )
      {

        this.hideTextTutorial();
        this.hideHightlight();

        return;

      }

      const wantedText = translate( this.$i18n.locale, 'tutorials.' + eventType );


      //console.log( 'eventType', eventType, eventDetails );

      //   __      __        _
      //   \ \    / /       | |
      //    \ \  / /__  _ __| |_ _____  __
      //     \ \/ / _ \| '__| __/ _ \ \/ /
      //      \  / (_) | |  | ||  __/>  <
      //       \/ \___/|_|   \__\___/_/\_\
      //
      //
      if ( TUTORIAL_EVENTS.CHOOSE_VORTEX === eventType )
      {

        const initialX = textX ? textX : '50%';
        const initialY = textY ? textY : '30%';

        layoutMode = 'center-upwards';

        // layout should be 'center'
        this.showTextTutorial( layoutMode, wantedText, initialX, initialY );

      }

        //    _____       _ _   _       _   _______ _
        //   |_   _|     (_) | (_)     | | |__   __| |
        //     | |  _ __  _| |_ _  __ _| |    | |  | |__   ___ _ __ ___   ___
        //     | | | '_ \| | __| |/ _` | |    | |  | '_ \ / _ \ '_ ` _ \ / _ \
        //    _| |_| | | | | |_| | (_| | |    | |  | | | |  __/ | | | | |  __/
        //   |_____|_| |_|_|\__|_|\__,_|_|    |_|  |_| |_|\___|_| |_| |_|\___|
        //
      //
      else if ( TUTORIAL_EVENTS.CHOOSE_INITIAL_THEME === eventType )
      {

        const initialX = textX ? textX : '50%';
        const initialY = textY ? textY : '30%';

        layoutMode = 'center-upwards';

        // layout should be 'center'
        this.showTextTutorial( layoutMode, wantedText, initialX, initialY );

      }


        //    _______        _   _                       _       _
        //   |__   __|      | | (_)                     (_)     | |
        //      | | ___  ___| |_ _ _ __ ___   ___  _ __  _  __ _| |
        //      | |/ _ \/ __| __| | '_ ` _ \ / _ \| '_ \| |/ _` | |
        //      | |  __/\__ \ |_| | | | | | | (_) | | | | | (_| | |
        //      |_|\___||___/\__|_|_| |_| |_|\___/|_| |_|_|\__,_|_|
        //
      //
      else if ( TUTORIAL_EVENTS.RECORD_TESTIMONIAL === eventType )
      {
        const { x, y, hightlightX, hightlightY } = this.findTestimonyShareButton();


        // layout should be 'top-left-of'
        this.showTextTutorial( layoutMode, wantedText, x, y );


        if ( eventHighlights.length < 1 )
        {
          eventHighlights = [ {
            x : hightlightX,
            y : hightlightY,
          } ]
        }

      }


        //    ____                     _                           _
        //   |  _ \                   | |                         | |
        //   | |_) |_ __ ___  __ _  __| | ___ _ __ _   _ _ __ ___ | |__  ___
        //   |  _ <| '__/ _ \/ _` |/ _` |/ __| '__| | | | '_ ` _ \| '_ \/ __|
        //   | |_) | | |  __/ (_| | (_| | (__| |  | |_| | | | | | | |_) \__ \
        //   |____/|_|  \___|\__,_|\__,_|\___|_|   \__,_|_| |_| |_|_.__/|___/
        //
      //
      else if ( TUTORIAL_EVENTS.BREADCRUMBS_THEMES === eventType )
      {

        const { x, y } = this.findFirstBreadcrumb();

        // layout should be 'top-right-of'
        this.showTextTutorial( layoutMode, wantedText, x, y );

        if ( eventHighlights.length < 1 )
        {
          eventHighlights = [ {
            x : x,
            y : y,
          } ]
        }

      }

        //    _____  _                               _______ _                                ____ _______ _   _
        //   |  __ \(_)                             |__   __| |                              |  _ \__   __| \ | |
        //   | |  | |_ ___  ___ _____   _____ _ __     | |  | |__   ___ _ __ ___   ___  ___  | |_) | | |  |  \| |
        //   | |  | | / __|/ __/ _ \ \ / / _ \ '__|    | |  | '_ \ / _ \ '_ ` _ \ / _ \/ __| |  _ <  | |  | . ` |
        //   | |__| | \__ \ (_| (_) \ V /  __/ |       | |  | | | |  __/ | | | | |  __/\__ \ | |_) | | |  | |\  |
        //   |_____/|_|___/\___\___/ \_/ \___|_|       |_|  |_| |_|\___|_| |_| |_|\___||___/ |____/  |_|  |_| \_|
        //
      //
      else if ( TUTORIAL_EVENTS.DISCOVER_MORE_THEMES === eventType )
      {

        const { x, y, hightlightX, hightlightY } = this.findDiscoverOtherThemesButton();


        if ( eventHighlights.length < 1 )
        {
          eventHighlights = [ {
            x : hightlightX,
            y : hightlightY,
          } ]
        }


        // layout should be 'top-left-of'
        this.showTextTutorial( 'top-left-of', wantedText, x, y );

      }


      //    _    _ _       _     _ _       _     _
      //   | |  | (_)     | |   | (_)     | |   | |
      //   | |__| |_  __ _| |__ | |_  __ _| |__ | |_ ___
      //   |  __  | |/ _` | '_ \| | |/ _` | '_ \| __/ __|
      //   | |  | | | (_| | | | | | | (_| | | | | |_\__ \
      //   |_|  |_|_|\__, |_| |_|_|_|\__, |_| |_|\__|___/
      //              __/ |           __/ |
      //             |___/           |___/
      // for now, let's base the highlight simply on if we get coordinates or not
      if ( highlightX && highlightY )
      {
        this.highlights = [ {
          x : this.calcResponsivePositionX( highlightX ),
          y : this.calcResponsivePositionY( highlightY ),
        } ]

      }

      if ( eventHighlights && eventHighlights.length > 0 )
      {

        eventHighlights = eventHighlights.map( h =>
        {
          return {
            x : this.calcResponsivePositionX( h.x ),
            y : this.calcResponsivePositionY( h.y ),
          }
        } )

        // console.log( 'HIGHLIGHTS', eventHighlights )
        this.highlights = eventHighlights;
      }

    },


    showTextTutorial ( layoutMode, text, x = false, y = false )
    {

      // console.log( 'Tutorials: going to show a text tutorial. ', layoutMode, text, x, y );

      this.isTextTutorialVisible = true;

      // make our default a centered text
      if ( !x || !y )
      {

        if ( window.innerWidth < 768 )
        {

          x = '50%'; //window.outerWidth / 2;
          y = '75%'; //window.outerHeight / 4 * 3; // for now, at 3/4 of the screen height (on small devices)
        } else
        {

          x = '50%'; //window.outerWidth / 2;
          y = '66.6%'; //window.outerHeight / 3 * 2; // for now, at 2/3 of the screen height
        }

      }


      this.textTutorialX = x;
      this.textTutorialY = y;

      this.layoutMode = layoutMode;

      this.textContent = text;

      // wanted to be able to pass a percentage value as well
      this.$refs.tutorialTextContainer.style.top  = typeof y === 'number' ? this.textTutorialY + 'px' : this.textTutorialY;
      this.$refs.tutorialTextContainer.style.left = typeof x === 'number' ? this.textTutorialX + 'px' : this.textTutorialX;

      // console.log( 'About to showTextTutorial ', x, y, layoutMode, text )

    },


    hideTextTutorial ()
    {

      this.$refs.tutorialTextContainer.classList.add( 'fadeout' );

      setTimeout( () =>
      {
        this.isTextTutorialVisible = false;
      } )
    },


    hideHightlight ()
    {
      this.highlights = [];
    },


    findTestimonyShareButton ()
    {
      const btn = document.querySelector( '.btn-share-testimony' );

      if ( !btn )
      {
        return {
          x : 0,
          y : 0,
        };
      }


      const btnBounds = btn.getBoundingClientRect();
      const btnTop    = btnBounds.top;
      const btnLeft   = btnBounds.left;

      return {
        x           : btnLeft,
        y           : btnTop,
        hightlightY : btnBounds.top + (btnBounds.height / 2),
        hightlightX : btnBounds.left + (btnBounds.width / 2),
      }

    },


    findFirstBreadcrumb ()
    {
      const firstBreadcrumb = document.querySelector( '.breadcrumb li:first-child img' );

      if ( !firstBreadcrumb )
      {
        return {
          x : 0,
          y : 0,
        };
      }


      const firstBreadcrumbBounds = firstBreadcrumb.getBoundingClientRect();
      const firstBreadcrumbTop    = firstBreadcrumbBounds.top + (firstBreadcrumbBounds.height / 2);
      const firstBreadcrumbLeft   = firstBreadcrumbBounds.left + (firstBreadcrumbBounds.width / 2);

      return {
        x : firstBreadcrumbLeft,
        y : firstBreadcrumbTop,

      }

    },


    findDiscoverOtherThemesButton ()
    {
      const btn = document.querySelector( '.btn-other-themes' );

      if ( !btn )
      {
        return {
          x : 0,
          y : 0,
        };
      }


      const btnBounds = btn.getBoundingClientRect();
      const btnTop    = btnBounds.top;
      const btnLeft   = btnBounds.left + btnBounds.width;


      return {
        x           : btnLeft,
        y           : btnTop,
        hightlightY : btnBounds.top + (btnBounds.height / 2),
        hightlightX : btnBounds.left + (btnBounds.width / 2),

      }

    },

    calcResponsivePositionX ( val )
    {
      const relativeX = val / window.innerWidth * 100 + '%';
      // console.log( 'relativeX', relativeX );
      return relativeX;
    },
    calcResponsivePositionY ( val )
    {
      const relativeY = val / window.innerHeight * 100 + '%';
      // console.log( 'relativeY', relativeY );
      return relativeY;
    },
  },


}
</script>

<style lang="scss">
@import "./Tutorial.scss";
</style>
